<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hyyDuh/images/cover.jpg?1718754719774" alt="This image is the cover for the book Compass"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Compass
      </h1>
      <p class="bookDescription body article font2">
        <p>-</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Murray Lee
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Publerati
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?305ff174